module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_vm._v("\n    Who would you like to share this form with?\n    "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('client-list', {
    attrs: {
      "with-create": false,
      "show-list-initially": false
    },
    on: {
      "relationshipselected": _vm.setRelationship
    }
  }), _vm._v(" "), (_vm.relId && _vm.url) ? _c('share-card', {
    attrs: {
      "links": [_vm.url],
      "relationship-id": _vm.relId
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-footer', {
    staticClass: "caption"
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n    To share a form with a client. From the client detail page:\n    client info -> forms -> share a form\n    ")], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d72dbe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Integrations/JotForm/ShareForm.vue
// module id = 1653
// module chunks = 0